import React, { lazy, Suspense } from "react";
import {
  getCompanyUrlAliasFromUrl,
  useCompanyIdFromUrl,
} from "@/hooks/companies/useCompanyIdFromUrl";
import AppNavBar from "../menu/nav-bar";
import ErrorBoundary from "@/components/errorBoundary";
import LoadingPanel from "@/components/loadingPanel";
import Routes from "../../routes";
import { cn } from "@/components/utils";
import { useAiChatPanel } from "./aiChatPanel";

// Lazy so that the chat's dependencies stay out of the main bundle. One of them
// has a lookbehind regex, which stops the whole file parsing in Safari < 16.4.
const AiChat = lazy(() =>
  import("@/components/aiChat/aiChat").then(({ AiChat }) => ({
    default: AiChat,
  })),
);

export function MainContent({ appMenusShow, isCompanyPage, pathname }) {
  const companyUrlAlias = getCompanyUrlAliasFromUrl();
  const companyId = useCompanyIdFromUrl();
  const { isAiChatCollapsed, isInvonoAdmin, setAiChatCollapsed } =
    useAiChatPanel();
  const isCompanyLandingPage =
    pathname === `/${companyUrlAlias}` || pathname === `/${companyUrlAlias}/`;
  const showAiChat =
    isInvonoAdmin && Boolean(companyUrlAlias) && !isCompanyLandingPage;
  const showExpandedAiChat = showAiChat && !isAiChatCollapsed;

  return (
    <div className="flex h-[100vh] flex-1 flex-col overflow-x-auto pb-0">
      <div className="h-[50px]">
        {appMenusShow && (
          <AppNavBar isCompanyPage={isCompanyPage} showAiChat={showAiChat} />
        )}
      </div>
      <div
        className={cn(
          "grid h-full w-full overflow-hidden transition-[grid-template-columns] duration-300 ease-out motion-reduce:transition-none",
          showAiChat
            ? showExpandedAiChat
              ? "grid-cols-[minmax(0,1fr)_600px]"
              : "grid-cols-[minmax(0,1fr)_0px]"
            : "grid-cols-1",
        )}
      >
        <div className="h-full w-full overflow-auto">
          <ErrorBoundary className="flex-1" resetKeys={[pathname]}>
            <Routes />
          </ErrorBoundary>
        </div>
        {showAiChat && (
          <div className="h-full min-w-0 overflow-hidden">
            {showExpandedAiChat && (
              <div className="p-md flex h-full w-full items-center justify-center overflow-hidden pl-0">
                <ErrorBoundary>
                  <Suspense fallback={<LoadingPanel />}>
                    <AiChat
                      companyId={companyId}
                      onClose={() => setAiChatCollapsed(true)}
                    />
                  </Suspense>
                </ErrorBoundary>
              </div>
            )}
          </div>
        )}
      </div>
    </div>
  );
}
